/**
 * analytics-shared/hooks/useFieldCatalog.js
 *
 * Object & field metadata, cached per-object. Builder calls this once and
 * receives a stable shape regardless of whether data came from fixtures or
 * the future GET /metadata/objects endpoint.
 */
import { useQuery } from './queryShim';
import { metadataApi } from '../api/metadataApi';

export function useObjectCatalog() {
  return useQuery({
    queryKey: ['metadata', 'objects'],
    queryFn: () => metadataApi.listObjects(),
    staleTime: 5 * 60_000,
  });
}

export function useObject(objectKey) {
  return useQuery({
    queryKey: ['metadata', 'object', objectKey],
    queryFn: () => metadataApi.getObject(objectKey),
    enabled: !!objectKey,
    staleTime: 5 * 60_000,
  });
}

export function useFieldMap(objectKey) {
  return useQuery({
    queryKey: ['metadata', 'fieldMap', objectKey],
    queryFn: () => metadataApi.getFieldMap(objectKey),
    enabled: !!objectKey,
    staleTime: 5 * 60_000,
  });
}
